class SyntaxError extends Error {
  constructor(errorMessage, defaultMessage = 'Whoops! Something went wrong.') {
    super(defaultMessage);
    this.name = 'SyntaxError';
    this.errorMessage = errorMessage;
  }
}

export default SyntaxError;
